import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Drawer, Button, message } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useQueryClient } from 'react-query';

import useAPIMutation from '../api/useAPIMutation';
import useAPIQuery from '../api/useAPIQuery';
import Form from '../components/Form';
import OAuthClientForm, { OAuthClientFormValues } from '../components/OAuthClientForm';
import PageTitle from '../components/PageTitle';
import useTypedNavigate from '../hooks/useTypedNavigate';
import useTypedParams from '../hooks/useTypedParams';
import { withRouteChange } from '../services/APM';
import styles from './CreateUser/CreateUser.module.css';

const CreateOAuthClient = () => {
  const [form] = Form.useForm<OAuthClientFormValues>();
  const queryClient = useQueryClient();

  const { tenant } = useTypedParams({ tenant: String });
  const navigate = useTypedNavigate();

  const user = useAPIQuery('/users/me/');

  const mutation = useAPIMutation(
    async (variables: OAuthClientFormValues, api) => {
      await api.post(`/oauth-clients/`, {
        client_id: '',
        client_name: variables.clientName,
        user: user.data?.id || 0,
        public_key: variables.publicKey,
      });
    },
    {
      onSuccess: () => {
        message.success('Client criado com sucesso!');
        navigate({
          pathname: '/:tenant/settings/cs-staff/external-integrations/api/',
          params: { tenant },
        });
      },
      onSettled: () => {
        queryClient.invalidateQueries('/oauth-clients/');
      },
    }
  );

  return (
    <Drawer
      className={styles.drawer}
      title={
        <PageTitle
          title="Novo OAuth Client"
          level={2}
          extra={[
            <Button
              key="close"
              type="text"
              onClick={() =>
                navigate({
                  pathname: '/:tenant/settings/cs-staff/external-integrations/api/',
                  params: { tenant },
                })
              }
              shape="circle"
            >
              <CloseOutlined />
            </Button>,
          ]}
        />
      }
      maskClosable
      size="large"
      closable={false}
      width={720}
      footer={
        <Button
          type="primary"
          htmlType="submit"
          icon={<PlusOutlined />}
          loading={mutation.isLoading}
          onClick={() => form.submit()}
        >
          Adicionar
        </Button>
      }
      open
      onClose={() =>
        navigate({
          pathname: '/:tenant/settings/cs-staff/external-integrations/api/',
          params: { tenant },
        })
      }
    >
      <Helmet>
        <title>Novo Client | Recrutamento e Seleção</title>
      </Helmet>
      <OAuthClientForm
        form={form}
        layout="vertical"
        onFinish={(variables) => {
          mutation.mutate(variables);
        }}
      />
    </Drawer>
  );
};

export default withRouteChange()(CreateOAuthClient);
